'use es6';

import { getAllFilters } from '../../report/configReportGetters';
export const getFilterByProperty = (config, property, missingValue = null) => {
  return getAllFilters(config).find(filter => filter.get('property') === property) || missingValue;
};